// extracted by mini-css-extract-plugin
export default {"scan-window":"QrCode_scan-window__TuzOm","qrscan-panel":"QrCode_qrscan-panel__xK17k","errorMessage":"QrCode_errorMessage__TTdaJ"};